import NProgress from 'nprogress';
import { lg, cloneDeep, util, isCorrectVal, isDate } from 'utils';
import $http from '$http';

//组件
// import baseInfoForm from 'agent-base-info';

export default {
    components: {},
    props: {},
    data() {
        return {
            lists: [],
            query: this.getQueryParam(),
            pageSizes: [10, 20, 50],
            totalSize: "",
            loading2: false,
            dialogVisible: false
        }
    },
    methods: {
        getQueryParam() {
            return cloneDeep({
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 10,
                total: 0,
                AgentId: "",
                OrderCode: "",
                startDate: "",
                endDate: ""
            });
        },
        onQuerySubmit() {
            if (!util.compareDate(util.time2str(this.query.endDate), util.time2str(this.query.startDate))) {
                this.$message.error('结束日期必须大于开始日期！');
                return;
            }

            this.getInitData();
        },
        //分页选定行
        handleSizeChange: function (val) {
            this.query.pageSize = val;
            this.getInitData();
        },
        //分页监听dd页面
        handleCurrentChange: function (val) {
            this.query.pageIndex = val;
            this.getInitData();
        },
        show(options) {
            let opts = $.extend({}, {
                agentId: ""
            }, options);
            this.dialogVisible = true;
            this.query.AgentId = opts.agentId;
            this.getInitData();
        },
        getInitData(agentId) {
            this.loading2 = true;
            $http.get('api/Kingdee/GetKingdee_ReceivablesByPage', this.query).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                
                util.doResult(this, res, () => {
                    this.query.total = Cnt;
                    this.loading2 = false;
                    this.lists = Data;
                });
            });
        },
        closeCallback() {
            this.query = this.getQueryParam();
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/kingdeeDialog/vm.js